import { BFFAgent } from '../../BFFAgent'
import { REACT_APP_IMG } from '../../../common/config'

// En base a un array de imagenes en base64m
// Carga las mismas utilizando el Bff de files
// Y devuelve un array de images
export const addImages = async (images = []) => {
    const mapImages = images.map(async image => {
        if (image.file) {
            // si tiene la propiedad file, es una imagen que hay que subir al micro de files
            const imageInfo = await BFFAgent.Files.addFile(image.file)
            const urlImage = `${REACT_APP_IMG}/${imageInfo.url}`
            delete image.file
            image.src = urlImage
        }
        return image
    })

    const result = await Promise.all(mapImages)

    return result
}
